// url.js
import { BASE_URL } from './root_url';
export const MOBILE_URL = `${BASE_URL}/v1/mobile`;

// auth
export const CHECK_TAKEN = `${BASE_URL}/v1/baseuser/checktaken/`;
export const FORGET_USERNAME_URL = `${BASE_URL}/v1/mobile/account/forgot-username/`;
export const FORGET_PASSWORD_URL = `${BASE_URL}/v1/mobile/account/forgot-password/`;
export const LOGIN_URL = `${BASE_URL}/api-token-auth/`;
export const RESET_PASSWORD_URL = `${MOBILE_URL}/account/change-password/`;
export const RESET_EMAIL_URL = `${MOBILE_URL}/account/req-reset-password/`;
export const RESET_PASSWORD = `${MOBILE_URL}/account/reset-password/`;
export const PHONE_ACTIVE_CODE = `${MOBILE_URL}/account/phone_activecode/`;
export const SIGNUP_URL = `${BASE_URL}/v1/baseuser/register/customer/`;
export const SEND_VERIFICATION_CODE = `${MOBILE_URL}/account/verify-active/`;
export const CHANGE_PASSWORD = `${MOBILE_URL}/account/change-password/`;
export const AUTH2_TOKEN_URL_GOOGLE = `${BASE_URL}/google-token-auth/`;
export const AUTH2_TOKEN_URL_WECHAT = `${BASE_URL}/wechat-token-auth/`;
export const AUTH2_TOKEN_URL_FACEBOOK = `${BASE_URL}/facebook-token-auth/`;
export const AUTH2_TOKEN_URL_APP_WECHAT = `${BASE_URL}/wechat-app-token-auth/`;
export const AUTH2_TOKEN_URL_APP_APPLE = `${BASE_URL}/appleid-app-token-auth/`;
export const DELETE_ACCOUNT_URL = `${BASE_URL}/v1/baseuser/deleteAccount/`;

// profile
export const ADDRESS_URL = `${MOBILE_URL}/address`;
export const CUSTOMER_INFORMATION_URL = `${BASE_URL}/v1/customer/oao/`;
export const DEFAULT_ADDRESS_URL = `${MOBILE_URL}/address/default`;
export const USER_CONFIG_URL = `${MOBILE_URL}/user_config`;
export const VERIFY_EMAIL_URL = `${MOBILE_URL}/account/verify_email_req`;
export const UPDATE_USER_PHOTO = `${MOBILE_URL}/account/upload_profile`;
export const GET_SUBSCRIBE_EMAIL = `${MOBILE_URL}/get_subscribe_via_email`;
export const POST_SUBSCRIBE_EMAIL = `${MOBILE_URL}/subscribe_via_email`;
export const PUT_UNSUBSCRIBE_EMAIL = `${MOBILE_URL}/unsubscribe_via_email`;
export const FETCH_PROMOTION_DATA = `${MOBILE_URL}/promotions/`;
export const FRIENDS_DATA = `${BASE_URL}/v1/baseuser/recommenderinfo`;
export const UPDATE_ACCOUNT_INFO = `${MOBILE_URL}/account/update_profile`;
export const SEND_VERIFY_EMAIL = `${MOBILE_URL}/account/verify_email_request`;
export const CHECK_VERIFY_EMAIL = `${MOBILE_URL}/account/verify_email_user_code`;

// product
export const BILLBOARD_URL = `${MOBILE_URL}/billboard/`;
export const CATEGORY_URL = `${MOBILE_URL}/category/`;
export const CATEGORY_2_URL = `${MOBILE_URL}/category2/`;
export const PRODUCTS_URL = `${MOBILE_URL}/product/`;
export const SEARCH_PRODUCT_URL = `${MOBILE_URL}/product/`;
export const PRODUCTS_GROUP = `${MOBILE_URL}/group`;
export const BRAND_OPTIONS_URL = `${MOBILE_URL}/product/brands/`;
export const FAVORITES_URL = `${MOBILE_URL}/favorite/`;
export const FAVORITES_BY_CATEGORY_URL = `${MOBILE_URL}/favorite/by_category`;
export const FAVORITES_UNFAVORITE_URL = `${MOBILE_URL}/unfavorite/`;
export const FETCH_PRODUCT_REVIEWS =`${BASE_URL}/v1/product/product_by_user`;
export const POST_PRODUCT_REVIEWS =`${BASE_URL}/v1/product/comment_product`;

// checkout
export const ANYWHERE_COMMERCE_URL = `${BASE_URL}/v1/acpayment/store_card/`;
export const CHECKOUT_URL = `${MOBILE_URL}/order/`;
export const CHECKOUT_TOUR_URL = `${MOBILE_URL}/consolidated-checkout/`;
export const VALIDATE_DELIVERY_RADIUS_URL = `${MOBILE_URL}/check_address_location`;
export const VALIDATE_PROMO_CODE_URL = `${MOBILE_URL}/promocode/`;
export const ZIPCODE_URL = `${BASE_URL}/v1/purchase/taxarea/`
export const ZIPCODE_URL_NO_LOGIN = `${BASE_URL}/v1/purchase/taxareanotlogin/`
export const GUEST_SIGNUP = `${BASE_URL}/v1/baseuser/register/customer_guest/`

// order
export const CONSOLIDATED_ORDERS_URL = `${MOBILE_URL}/consolidated-orders`;
export const DISPATCH_PORTAL_URL = `${BASE_URL}/v1/sale/sales_mobile_order/external`;
export const MOBILE_SALES_ORDERS_URL = `${BASE_URL}/v1/sale/sales_mobile_order/search/`;
export const ORDER_URL = `${MOBILE_URL}/order/`;
export const PENDING_ORDERS_URL = `${MOBILE_URL}/pending-orders`;
export const SALES_ORDER_URL = `${MOBILE_URL}/sales_order/`;
export const SALES_INVOICE_URL = `${MOBILE_URL}/sales_invoice/`;

// contact
export const CONTACT_URL = `${BASE_URL}/v1/contact/info/`;

//cart
export const CART_URL = `${BASE_URL}/v1/mobile/cart`

//become a driver
export const DRIVERAPPLY = `${BASE_URL}/v1/baseuser/mmdriver-application`

// ACH url
export const ACH_PROFILE_URL = `${BASE_URL}/v1/customer/authorize_profiles/`;
export const EDIT_CARD_URL = `${BASE_URL}/v1/customer/update_saved_card/`;
export const DELETE_CARD_URL = `${BASE_URL}/v1/customer/delete_saved_card/`;



// WEBPACK FOOTER //
// ./src/api/url.js